<script>
  import {updateQueryParam} from '../utils.js';
  export let updatable;
  export let panels;

  const LEFT_WIDTH = 240;
  const BUTTONS_WIDTH = 60;

  let width, lastWidth, maxWidth;

  let leftPanel = true;
  let buttonPanel = true;
  let rightPanel;
  let expanded;


  let showLeftButton;
  let showRightButton;
  // let rightPanelFlexGrow;

  $: {
    updatable ? "" : "";
    let urlSearchParams = new URLSearchParams(window.location.search);
    rightPanel = urlSearchParams.get('rightPanel');
    expanded = (urlSearchParams.get('expanded') && true) || false;
    (() => null)('here', updatable)

    maxWidth = panels.map(x => x[2] || 0).reduce((p, v) => (p > v? p : v), 0)
    if (width > maxWidth + LEFT_WIDTH + BUTTONS_WIDTH && !expanded) {
      showLeftButton = false;
      showRightButton = false;
      leftPanel = true;
      buttonPanel = true;

    } else if (width > maxWidth + BUTTONS_WIDTH) {
      showLeftButton = true;
      showRightButton = false;
      buttonPanel = true;
      leftPanel = false;
    } else {
      showLeftButton = true;
      showRightButton = true;
      if (lastWidth === undefined) {
        leftPanel = !showLeftButton;
        buttonPanel = !showRightButton;
      }
    }

    lastWidth = width;
    // console.log(width, lastWidth, leftPanel, rightPanel, rightPanelFlexGrow)
    // if (width < 1400 && (lastWidth === undefined || lastWidth > 1400 ) && leftPanel && rightPanel) {
    //   rightPanel = null;
    // } 
    // if (width < 900 && (lastWidth === undefined || lastWidth > 900 ) && (leftPanel || rightPanel)) {
    //   rightPanel = null;
    //   leftPanel = false;
    // }
    // lastWidth = width;
    // rightPanelFlexGrow = width < 700 ? 7000 : width > 1400 ? 1 : 700/(width-699.9);
  }

  function transition(_, {
    delay = 0,
    duration = 200,
    css = t => `width: ${t*100}%`
  }) {

    return {
      delay,
      duration,
      css
    };
  }
</script>

<div class="flex-container">
  {#if leftPanel}
    <div class="panel" style='flex-basis: {LEFT_WIDTH}px; flex-grow: 0; flex-shrink: 0;' 
    transition:transition="{{css: t => `flex-basis: ${LEFT_WIDTH*t}px;`}}">
      <div style='flex-grow: 1'/>
      <slot name="left"/>
      <div style='flex-grow: 1'/>
    </div>
  {/if}
  {#if showLeftButton}
    <div class="button-column" style="border-left: solid 0.1px #3332">
      <div class="panel" style="justify-content: center; ">
        <div class="panel-button" style="width: 30px" id="left-button"on:click={() => {
          leftPanel = !leftPanel
          // rightPanel = width < 1600 ? null : rightPanel;
        }}>
          {leftPanel ? '◀' : '☰'}
        </div>
      </div> 
    </div>
  {/if}
  {#if !expanded}
    <div class="panel" style="flex-grow: 1; flex-shrink: 1000; flex-basis: 1000px">
      <div style='flex-grow: 1'/>
      <slot name="main"/>
      <div style='flex-grow: 1'/>
    </div>
  {/if}
  {#if rightPanel != null}
    <div  style='flex-basis: {panels[rightPanel][2] || 300}px; border: none; flex-shrink: 1; flex-grow: {expanded*1};' 
    transition:transition={{css: t => `flex-basis: ${t*300}`}}
    >
      <div style='display: flex; gap: 10px; align-items: center; padding-left: 5px; padding-right: 5px; height: 20px'>
        {#if expanded}
          <img src='/assets/contract.svg' alt='Contract' style="cursor: pointer; height: 12px" on:click={() => {expanded = false; updateQueryParam('expanded')}}/>
        {:else}
          <img src='/assets/expand.svg' alt='Expand' style="cursor: pointer; height: 12px" on:click={() => {expanded = true; updateQueryParam('expanded', expanded)}}/>
        {/if}
        <div style='flex-grow: 1;'/>
        <span style='cursor: pointer' on:click={() => {rightPanel = null; expanded = false; updateQueryParam('expanded'); updateQueryParam('rightPanel')}}> &#x2715;</span>
      </div>
      <div class="panel" style='height: calc(92vh - 19px)'>
        {#if rightPanel == '0'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='0'/>
          </div>
        {/if}
        {#if rightPanel == '1'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='1'/>
          </div>
        {/if}
        {#if rightPanel == '2'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='2'/>
          </div>
        {/if}
        {#if rightPanel == '3'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='3'/>
          </div>
        {/if}
        {#if rightPanel == '4'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='4'/>
          </div>
        {/if}
        {#if rightPanel == '5'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='5'/>
          </div>
        {/if}
        {#if rightPanel == '6'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='6'/>
          </div>
        {/if}
        {#if rightPanel == '7'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='7'/>
          </div>
        {/if}
        {#if rightPanel == '8'}
          <div class='right-panel' transition:transition={{css: t => `height: ${t*100}%;`}} >
            <slot name='8'/>
          </div>
        {/if}
      </div>
    </div>
  {/if}
  {#if showRightButton}
    <div class="button-column" style="border-right: solid 0.1px #3332">
      <div class="panel" style="justify-content: center; ">
        <div class="panel-button" style="width: 30px" id="right-button"on:click={() => {
          buttonPanel = !buttonPanel
          // rightPanel = width < 1600 ? null : rightPanel;
        }}>
          {buttonPanel ? '▶' : '⋮'}
        </div>
      </div> 
    </div>
  {/if}
  {#if buttonPanel}
    <div class="buttons-panel" style='flex-basis: {BUTTONS_WIDTH}px;' 
    transition:transition="{{css: t => `flex-basis: ${BUTTONS_WIDTH*t}px`}}">
      {#each panels as [name, icon], index}
        {#if !panels[index][4]}
          <div class='icon' style={rightPanel == index ? "opacity: 1": panels[index][3]? "opacity: 1":""} on:click={() => {
            expanded = rightPanel == index ? false : expanded;
            rightPanel = rightPanel == index ? null : index; 
            buttonPanel = !showRightButton;
            expanded ? updateQueryParam('expanded', expanded) : updateQueryParam('expanded'); 
            updateQueryParam('rightPanel', rightPanel)
          }}>
            <img style={rightPanel == index ? 'filter: hue-rotate(171deg) grayscale(10%) brightness(2); opacity: 1': 
              panels[index][3] ? 'filter: hue-rotate(40deg) grayscale(10%) brightness(5); opacity: 1' : ''} src={icon} alt={name + ' icon'}/>
            <p style="font-size: 0.7em; font-family: 'Arial Narrow'; margin: 0; {rightPanel == index ? "color: var(--primary)": panels[index][3] ? "color: var(--secondary)" :""}">{name}</p>
          </div>
        {/if}
      {/each}
      </div>
  {/if}
</div>

<window bind:clientWidth={width} />

<style>
  .icon {
    /* width: 30px; */
    /* height: 30px; */
    /* border-radius: 15px; */
    opacity: 40%;
    display: flex;
    flex-direction: column;
    gap: 3px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .icon:hover {
    opacity: 100%;
    /* box-shadow: 0px 0px 5px #0004; */
  }
  .buttons-panel {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 30px;
    padding: 0;
    align-items: center;
  }
  img {
    height: 20px;
    width: 20px;
    filter: grayscale(100%);
    opacity: 90%;
  }
  .flex-container {
    display: flex;
    flex-direction: row;
    background-color: var(--background);
    flex-grow: 1000;
  }
  .panel {
    display: flex;
    height: 92vh;
    overflow-y: auto;
    flex-direction: column;
    justify-content: stretch;
    border-right: solid 0.2px #1111;
  }
  .right-panel {
    height: 100%;
  }
  /* .wrapper {
    flex-basis: 0;
    overflow-x: hidden;
    overflow-y: hidden;
  } */
  .button-column {
    overflow-x: visible;
    z-index: 1;
    flex-basis: 1px;
    pointer-events: none;
  }
  .panel-button {
    background-color: var(--tertiary); 
    opacity: 0.2;
    width: 40px; 
    color: var(--background);
    pointer-events: all; 
  }
  .panel-button:hover {
    opacity: 1;
  }
  #left-button {
    height: 60px; 
    border-top-right-radius: 30px; 
    border-bottom-right-radius: 30px;
    line-height: 53px;
    font-size: 24px;
  }
  #right-button {
    height: 60px; 
    border-top-left-radius: 30px; 
    border-bottom-left-radius: 30px;
    line-height: 53px;
    font-size: 24px;
  }
</style>